import CrudReducer from './crudReducer';

const cr = new CrudReducer('report');

const reportsReducer = cr.Reducer;

export default reportsReducer;
